module.exports = __webpack_public_path__ + "static/Menu_Tm-d60208daf3aeae7cbbbd80a7c600be71.pdf";